import React, { useRef, useState, Suspense } from 'react';
import { ReactEditor, useSlateStatic } from 'slate-react';
import Portal from 'generics/components/portal';
import InlineChromiumBugfix from './inline-chromium-bug-fix';
import { IconAdornment } from '../icon/svg';
import LoadingPopover from './loading';
import './index.scss';
import './popover.scss';

function FailedPopover(props) {
  return <LoadingPopover anchor={props.anchor} failed={true} />;
}

async function loadPopover() {
  try {
    return await import('./popover');
  } catch (exception) {
    return { default: FailedPopover };
  }
}
const Popover = React.lazy(loadPopover);

function Link(props) {
  const editor = useSlateStatic();
  const anchor = useRef(null);
  const [open, setOpen] = useState(false);

  function hide() { setOpen(false); }
  function show(event) {
    if (event.currentTarget.parentNode.getAttribute('contenteditable') === 'false') {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    setOpen(true);
  }

  function renderPopover() {
    if (open === false) {
      return null;
    }
    return <Portal><Suspense fallback={<LoadingPopover anchor={anchor} />}>
      <Popover editor={editor} element={props.element} anchor={anchor} hide={hide}
        path={ReactEditor.findPath(editor, props.element)} />
    </Suspense></Portal>;
  }

  return <a {...props.attributes} href={props.element.url} className="link" ref={anchor} onClick={show}>
    <InlineChromiumBugfix />
    <IconAdornment element={props.element} position="start" />
    {props.children}
    <IconAdornment element={props.element} position="end" />
    <InlineChromiumBugfix />
    {renderPopover()}
  </a>;
}

export default Link;
